import PDFProcedures from './PDFProcedures';
import moment from 'moment';

class PrintsProceduresPDF {

    async printPDF(id_admision, procedure, printInnerWindow) {
        let url = process.env.REACT_APP_PUBLIC_URL + 'admision/consultar-procedimiento-pdf';
        url = url + '?id_admision=' + id_admision;
        await fetch(url, {
            method: 'GET',
            headers: {
                authorization: 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(res => {
            let dataQuery = res.info;

            let perfil = JSON.parse(sessionStorage.getItem('clinica'));
 
            let genderDoctor = dataQuery.sexo_doctor;
            let prefixDoctor = 'Dr. ';
            switch (genderDoctor) {
                case 'Masculino':
                    prefixDoctor = 'Dr. ';
                    break;
                case 'Femenino':
                    prefixDoctor = 'Dra. ';
                    break;
            }
            let nameDoctor = prefixDoctor + dataQuery.nombre_doctor;
            let firmDoctor = process.env.REACT_APP_PUBLIC_URL + dataQuery.url_firma_doctor + '/' + sessionStorage.getItem('token');

            let dataService = this.validateProcedureNameAndCups(procedure, dataQuery.servicio.servicios);

            /*
            let nameService = dataQuery.servicio.servicios[0].nombre;
            let codigoService = dataQuery.servicio.servicios[0].codigo;
            */

            let validationProceduresAdmision = this.verifyAdmisionProceduresApply(dataQuery.servicio.servicios);

            let nameService = dataService.nombre;
            let codigoService = dataService.codigo;
            //let nameTempleteService = await getProcedureTemplate(dataService.formato);

            let professional = { especialidad: dataQuery.especialidad_doctor, reg_medico: dataQuery.reg_medico, num_documento_doctor: dataQuery.num_documento_doctor, tip_documento_doctor: dataQuery.tip_documento_doctor }

            let nameProcedureTitle = this.defineTitleProcedure(dataQuery.procedimiento, procedure);

            let dataPrint = {
                fullname: dataQuery.fullname,
                documentNumber: dataQuery.num_documento,
                typeDocument: dataQuery.tip_documento,
                typeOfDocument: dataQuery.tip_documento,
                profile: perfil,
                birthday: moment(dataQuery.fec_nacimiento).format('YYYY-MM-DD'),
                age: dataQuery.edad,
                gender: dataQuery.sexo,
                address: dataQuery.direccion.direccion,
                city: dataQuery.direccion.ciudad,
                telephone: dataQuery.telefono1,
                nitThird: dataQuery.nit_tercero,
                nameThird: dataQuery.nombre_tercero,
                regime: dataQuery.regimen_paciente,
                urlLogo: sessionStorage.getItem('logoURL'),
                nameDoctor: nameDoctor,
                specialtyDoctor: dataQuery.especialidad_doctor,
                medicalRegister: dataQuery.reg_medico,
                urlDoctorFirm: firmDoctor,
                nameService: nameService,
                codigoService: codigoService,
                eco: procedure == "ECO" || procedure == "TODOS" ? dataQuery.procedimiento.eco.eco[0] : null,
                estres: procedure == "STRESS" || procedure == "TODOS" ? dataQuery.procedimiento.estres.estres[0] : null,
                prueba: procedure == "TEST" || procedure == "TODOS" ? dataQuery.procedimiento.prueba.prueba[0] : null,
                ekg: procedure == "EKG" || procedure == "TODOS" ? dataQuery.procedimiento.ekg.ekg[0] : null,
                holter: procedure == "HOLTER" || procedure == "TODOS" ? dataQuery.procedimiento.holter.holter[0] : null,
                mapa: procedure == "MAPA" || procedure == "TODOS" ? dataQuery.procedimiento.mapa.mapa[0] : null,
                fecha: moment(dataQuery.procedimiento.fecha).format("DD/MM/YYYY"),
                hora: moment(dataQuery.procedimiento.hora.toString(), 'HH:mm:ss').format("h:mm:ss a"),
                id_ciudad_paciente: dataQuery.id_ciudad_paciente,
                id_admision: id_admision,
                celular: dataQuery.celular,
                fecha_admision: moment(dataQuery.fecha_admision).format("DD/MM/YYYY"),
                printInnerWindow,
                id_profesional: dataQuery.id_profesional,
                professional,
                nameProcedureTitle,
                formato_propio:dataQuery.formato_propio,
                formato_detalle:dataQuery.formato_detalle,
                id_contrato:dataQuery.id_contrato
            };
            PDFProcedures(dataPrint);
        }).catch((error) => {
            console.log(error);
            alert("Ha ocurrido un error generando el PDF");
        });
    }

    //Esteban Londoño Ospina 06/09/2022
    //Validacion de CUPS y Nombre
    validateProcedureNameAndCups = (procedure, services) => {
        let serviceData = null;
        switch (procedure) {
            case "ECO":
                serviceData = services.find(ser => parseInt(ser.formato) == 1);
                break;
            case "STRESS":
                serviceData = services.find(ser => parseInt(ser.formato) == 3);
                break;
            case "TEST":
                serviceData = services.find(ser => parseInt(ser.formato) == 4);
                break;
            case "HOLTER":
                serviceData = services.find(ser => parseInt(ser.formato) == 6);
                break;
            case "MAPA":
                serviceData = services.find(ser => parseInt(ser.formato) == 7);
                break;
            case "EKG":
                serviceData = services.find(ser => parseInt(ser.formato) == 2);
                break;
        }

        if (serviceData != null && serviceData != undefined) {
            return {
                nombre: serviceData.nombre,
                codigo: serviceData.codigo,
                formato: serviceData.formato
            }
        }
        else {
            return {
                nombre: services[0].nombre,
                codigo: services[0].codigo
            }
        }
    }

    verifyAdmisionProceduresApply = (servicios) => {

        let dataProc = {
            eco: servicios.some(ser => parseInt(ser.formato) == 1),
            stress: servicios.some(ser => parseInt(ser.formato) == 2),
            test: servicios.some(ser => parseInt(ser.formato) == 4),
            holter: servicios.some(ser => parseInt(ser.formato) == 6),
            mapa: servicios.some(ser => parseInt(ser.formato) == 7)
        }

        return dataProc;
    }

    defineTitleProcedure = (procedures, type) => {
        let nameProcedureTitle;
        switch (type) {
            case "ECO":
                nameProcedureTitle = procedures.eco.eco[0].nameTemplete;
                break;
            case "STRESS":
                nameProcedureTitle = procedures.estres.estres[0].nameTemplete;
                break;
            case "TEST":
                nameProcedureTitle = procedures.prueba.prueba[0].nameTemplete;
                break;
            case "HOLTER":
                nameProcedureTitle = procedures.holter.holter[0].nameTemplete;
                break;
            case "MAPA":
                nameProcedureTitle = procedures.mapa.mapa[0].nameTemplete;
                break;
            case "EKG":
                nameProcedureTitle = procedures.ekg.ekg[0].nameTemplete;
                break;
        }
        return nameProcedureTitle;
    }

    getProcedureTemplate = (formatoTemplete) => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-plantillas-procedimientos/consultar-por-tipo', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    tipo: formatoTemplete
                })
            }).then(response => {
                if (response.status == 200) {
                    return response.json();
                }
                else {
                    throw new Error("Ha ocurrido un error en el Servidor");
                }
            }).then(data => {
                resolve(data);
            }).catch((error) => {
                resolve([]);
            });
        })

    }
}

export default new PrintsProceduresPDF();


